"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAtomicMolecule = require("react-atomic-molecule");

var _ref =
/*#__PURE__*/
_react["default"].createElement(_reactAtomicMolecule.SemanticUI, {
  atom: "path",
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
});

var ChevronRight = function ChevronRight(props) {
  return _react["default"].createElement(_reactAtomicMolecule.SemanticUI, props, _ref);
};

ChevronRight.defaultProps = {
  viewBox: '0 0 24 24',
  atom: 'svg',
  width: '100%'
};
var _default = ChevronRight;
exports["default"] = _default;
module.exports = exports.default;